import clsx from 'clsx';
import { useParams, usePathname } from 'next/navigation';
import Link from 'next/link';
import { useMemo } from 'react';
import { Button } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { useCareerConfig } from '@/hooks/useCareerConfig/useCareerConfig';
export const CareerHeader = ({
  className
}) => {
  const {
    companySlug
  } = useParams();
  const pathname = usePathname();
  const {
    data: careerConfig
  } = useCareerConfig(companySlug);
  const companyLogoUrl = useMemo(() => {
    if (careerConfig?.showCompanyLogo) {
      return careerConfig.companyLogoUrl || `/images/logo/${companySlug}.png`;
    }
    return '';
  }, [careerConfig, companySlug]);
  const talentPoolApplyPath = `/${companySlug}/career/jobs/talent-pool`;
  const showTalentPoolLink = Boolean(careerConfig?.isCareerTalentPoolApplyEnabled) && pathname !== talentPoolApplyPath;
  return <div className={clsx(className, ' border-b mb-10')}>
            <div className="w-full max-w-6xl mx-auto py-4 px-2 flex items-center justify-between gap-4">
                <Link href={`/${companySlug}/career/jobs`} prefetch={false} className="flex items-center">
                    <div className="flex items-center gap-2">
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img src={companyLogoUrl || undefined} alt={companySlug || 'Company Logo'} className="cursor-pointer h-8 w-auto" />
                        <span className="text-xl font-bold">|</span>
                        <span className="text-xl font-medium">Careers</span>
                    </div>
                </Link>
                {showTalentPoolLink && <Button component={Link} href={talentPoolApplyPath} prefetch={false} variant="contained" disableElevation size="small" endIcon={<ChevronRight className="size-4" />} className="shrink-0" data-testid="career-header/talent-pool-link">
                        Join our talent pool
                    </Button>}
            </div>
        </div>;
};